import React, { useContext } from "react";
import {
  Box,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  HStack,
  useRadioGroup,
  Text,
  Flex,
  Image,
  VStack,
  StackDivider,
  Divider,
  Select,
} from "@chakra-ui/react";
import { HomeContext } from "../../../context/HomeContext";
import IconCardXL from "../../layouts/IconCardXL";
import Counter from "../../../assets/Counter";
import Picto1 from "./picto1/Picto1.png";
import Picto2 from "../Step3/picto1/Picto1.png";
import Picto3 from "../Step3/picto1/Picto2.png";
import Picto4 from "../Step3/picto1/Picto3.png";
import RadioCard from "../../layouts/RadioCard";

const StepOne = ({ onNext, onBack }) => {
  const [formData, setFormData] = useContext(HomeContext);

  const calculateConsoAnnuelleBallon = () => {
    if (formData.ballonThermoSelected === "0") {
      return 0; // Retourne 0 si le ballon thermo sélectionné est 0
    } else {
      const N12 = formData.depenseECS / 0.17;
      return N12 * 0.25; // Calcul habituel si le ballon thermo n'est pas 0
    }
  };
  formData.consoAnnuelleBallon = calculateConsoAnnuelleBallon();

  const calculateDepenseFutureBallon = () => {
    if (formData.ballonThermoSelected === "0") {
      return 0; // Si le ballon thermo est sélectionné à "0", retourner 0 pour la dépense future
    }
    return formData.consoAnnuelleBallon * 0.17; // Calcul habituel si le ballon n'est pas à "0"
  };
  formData.depenseFutureBallon = calculateDepenseFutureBallon();

  const calculateCoutProjetBallon = () => {
    if (formData.ballonThermoSelected === "Oui") {
      // Prix de base du ballon thermodynamique
      let coutBase = 3490;
      
      // Ajouter le prix du cache climat si sélectionné
      if (formData.cacheClimBallonSelected === "Avec") {
        coutBase += 590;
      }
      
      return coutBase;
    } else {
      return 0;
    }
  };

  formData.coutProjetBallon = calculateCoutProjetBallon();

  const maPrimeBallonMatrix = {
    bleu: 1200,
    jaune: 800,
    rose: 0,
    violet: 400,
  };

  const calculateMaPrimeBallon = () => {
    if (formData.ballonThermoSelected === "0") {
      return 0; // Si aucun ballon thermodynamique n'est sélectionné, retourner 0 pour la prime
    }
    const couleurAide = formData.aideColor.toLowerCase();
    return maPrimeBallonMatrix[couleurAide] || 0; // Retourne la prime selon la couleur d'aide, ou 0 si non définie
  };

  formData.maPrimeBallon = calculateMaPrimeBallon();

  const calculateAidesCeeBallon = () => {
    if (formData.ballonThermoSelected === "0") {
      return 0; // Si aucun ballon thermodynamique n'est sélectionné, retourner 0 pour les aides
    }
    
    // Vérification de la couleur d'aide
    if (formData.aideColor === "jaune" || formData.aideColor === "rose" || formData.aideColor === "violet") {
      return 97;
    } else if (formData.aideColor === "bleu") {
      return 114;
    } else {
      return 0;
    }
  };  

  formData.aidesCeeBallon = calculateAidesCeeBallon();

  const calculateDepenseFuturePompe = () => {
    const F21 = formData.pompeSelected ? parseInt(formData.pompeSelected) : 0;
    const F23 = formData.depenseECS;
    if (F21 === 0) {
      return 0;
    } else {
      const F22 = (F21 / 5) * 1000;
      return F22 * 0.17;
    }
  };
  formData.depenseFuturePompe = calculateDepenseFuturePompe();


  // Modifier ma fonction pour accepter 4 produits 16 et 4 a 18 en puissance 

  const coutProjetPompeMatrix = {
    "0": 0,
    "Pompe air eau Ariston Nimbus : 80 S (8 kw)": 17200,
    "Pompe air eau Thompson Ether (10 kw)": 17200,
    "Pompe air eau Atlantic Duo Ballon integre (11 kw)": 24650,
    "Pompe air eau Ariston Nimbus : 120 S (12 kw)": 19200,
    "Pompe air eau Atlantic Duo Ballon integre (14 kw)": 25650,
    "Pompe air eau Thompson Ether (14 kw)": 19800,
    "Pompe air eau Daikin Altherma 3H (14 kw)": 23700,
    "Pompe air eau Daikin Erla MT plancher chauffant (14 kw)": 22700,
    "Pompe air eau Ariston Nimbus : 150 S (15 kw)": 22650,
    "Pompe air eau Atlantic Duo Ballon integre (16 kw)": 26650,
    "Pompe air eau Thompson Ether (16 kw)": 23100,
    "Pompe air eau Daikin Altherma 3H (16 kw)": 24100,
    "Pompe air eau Daikin Erla MT plancher chauffant (16 kw)": 23100,
    "Pompe air eau Daikin Altherma 3H (18 kw)": 24650,
    "Pompe air eau FHE Inelio Mono-bloc Tri-phasé (22 kw)": 25700,
    "Pompe air eau FHE Inelio Mono-bloc Tri-phasé (26 kw)": 27700,
    "Pompe air eau FHE Inelio Mono-bloc Tri-phasé (30 kw)": 29700
};

const calculateCoutProjetPompe = () => {
    const selectedModel = formData.pompeModeleSelected;
    let coutProjet = coutProjetPompeMatrix[selectedModel] || 0;
    
    // Ajouter le prix du kit bi zone si sélectionné
    if (formData.bizoneSelected === "Avec") {
        coutProjet += 1660;
    }
    
    // Ajouter le prix du cache climat si sélectionné
    if (formData.cacheClimPompeEauSelected === "Avec") {
        coutProjet += 590;
    }

    // Ajouter le prix du désembouage si sélectionné
    if (formData.desembouage === "Avec") {
        coutProjet += 844;
    }
    
    return coutProjet;
};

formData.coutProjetPompe = calculateCoutProjetPompe();

  const calculateMaPrimePompe = () => {
    const F21 = formData.pompeSelected;
    const couleurAide = formData.aideColor.toLowerCase(); // Ensure case insensitivity

    // Check if no pump is selected and the aid color is rose
    if (F21 === "0" || couleurAide === "rose") {
      return 0;
    }

    const maPrimeValues = {
      bleu: 5000,
      jaune: 4000,
      rose: 0,
      violet: 3000,
    };

    return maPrimeValues[couleurAide] || 0;
};

formData.maPrimePompe = calculateMaPrimePompe();



const calculateAidesCeePompe = () => {
  const pompeSelected = formData.pompeSelected;
  const sourceType = formData.sourceType;
  const couleurAide = formData.aideColor;

  // Si la pompe n'est pas sélectionnée ou si le type de source est "Électricité", retournez 0
  if (pompeSelected === "0" || sourceType === "ELECTRICITE" ||sourceType === "CONDENSATION" ) {
      return 0;
  }

  // Utilisez une matrice unique pour toutes les sources
  const aidesCeeMatrix = {
      bleu: 4800,
      jaune: 4100,
      rose: 2800,
      violet: 2800,
  };

  return aidesCeeMatrix[couleurAide] || 0;
};


  formData.aidesCeePompe = calculateAidesCeePompe();

  const calculateProductionAnnuellePanneaux = () => {
    const T21 = parseFloat(formData.panneauxSelected);
    const U12 = formData.solarCoefficient;

    const productionAnnuelle = T21 * 425 * U12 * 1;

    return productionAnnuelle * 0.84 || 0;
  };

  formData.productionAnnuellePanneaux = calculateProductionAnnuellePanneaux();

  const calculateDepenseFuturePanneaux = () => {
    if (formData.panneauxSelected === "0") {
      return 0; // Retourne 0 si aucun panneau n'est sélectionné
    }
    const T22 = parseFloat(formData.consoAnnuellePanneaux);
    const T23 = parseFloat(formData.productionAnnuellePanneaux);
    const depenseFutureBase = (T22 - T23) * 0.17; // Calcule la dépense future basée sur la consommation et la production

    // Calculez 10% de la dépense annuelle
    const minDepenseFuture = T22 * 0.1; // 10% de la dépense annuelle

    // Assurez-vous que la dépense future ne soit pas inférieure à 10% de la dépense annuelle
    let depenseFuture = Math.max(depenseFutureBase, minDepenseFuture);

    // Appliquez une multiplication supplémentaire de 0.17 à la dépense future
    depenseFuture *= 0.17;

    return Math.round(depenseFuture);
  };

  formData.depenseFuturePanneaux = calculateDepenseFuturePanneaux();

  const calculateCoutProjetPanneaux = () => {
    const coutTable = {
      6: 15900,    // 3 kWc
      7: 17100,    // 3,5 kWc
      8: 19900,    // 4 kWc
      9: 22900,    // 4,5 kWc
      10: 23900,   // 5 kWc
      11: 24900,   // 5,5 kWc
      12: 26100,   // 6 kWc
      13: 27500,   // 6,5 kWc
      14: 28400,   // 7 kWc
      15: 29900,   // 7,5 kWc
      16: 30900,   // 8 kWc
      17: 32100,   // 8,5 kWc
      18: 33300,   // 9 kWc
      20: 34000,   // 10 kWc
      24: 34900,   // 12 kWc
      30: 36000,   // 15 kWc
      72: 46000,   // 36 kWc
    };
    const selectedPanels = parseInt(formData.panneauxSelected);
    let coutBase = coutTable[selectedPanels] || 0;
    
    // Ajouter le prix du carport bois si sélectionné
    if (formData.carportBoisSelected === "Avec") {
      coutBase += 4200;
    }
    
    // Ajouter le prix de la désinstallation des panneaux si sélectionnée
    if (formData.desinstallationPanneauxSelected === "Avec") {
      coutBase += 2200;
    }
    
    return coutBase;
  };
  formData.coutProjetPanneaux = calculateCoutProjetPanneaux();

  const calculatePrimeAutoConsoPanneaux = () => {
    const primeAutoConsoMatrix = {
      6: 240,
      7: 280,
      8: 320,
      9: 360,
      10: 400,
      11: 440,
      12: 480,
      13: 520,
      14: 560,
      15: 600,
      16: 640,
      17: 680,
      18: 720,
      20: 1900,
      24: 2280,
      30: 2850,
      72: 2880,  // 36 kWc
    };

    const selectedPanels = parseInt(formData.panneauxSelected);
    const primeAutoConso = primeAutoConsoMatrix[selectedPanels] || 0;
    return primeAutoConso;
  };

  // Example usage:
  formData.primeAutoConsoPanneaux = calculatePrimeAutoConsoPanneaux();

  const recuperationTvaMatrix = {
    6: 2340.76,   // 3 kWc (pose 371.09 + matériel 1969.67)
    7: 2850,      // 3,5 kWc
    8: 3316.67,   // 4 kWc
    9: 3816.67,   // 4,5 kWc
    10: 3983.33,  // 5 kWc
    11: 4150,     // 5,5 kWc
    12: 4350,     // 6 kWc
    13: 4583.33,  // 6,5 kWc
    14: 4733.33,  // 7 kWc
    15: 4983.33,  // 7,5 kWc
    16: 5150,     // 8 kWc
    17: 5350,     // 8,5 kWc
    18: 5550,     // 9 kWc
    20: 5666.67,  // 10 kWc
    24: 5816.67,  // 12 kWc
    30: 6000,     // 15 kWc
    72: 7666.67,  // 36 kWc
  };

  const calculateRecuperationTvaPanneaux = (selectedPanels) => {
    const parsedSelectedPanels = parseInt(selectedPanels);
    const recuperationTva = recuperationTvaMatrix[parsedSelectedPanels];
    return recuperationTva || 0;
  };

  const selectedPanels = formData.panneauxSelected;
  formData.recuperationTvaPanneaux =
    calculateRecuperationTvaPanneaux(selectedPanels);

  formData.coutProjet =
    formData.coutProjetPompe +
    formData.coutProjetBallon +
    formData.coutProjetPanneaux +
    formData.coutProjetPompeAirAir;
  formData.totalAide =
    formData.aidesCeePompe +
    formData.maPrimePompe +
    formData.maPrimeBallon +
    formData.aidesCeeBallon +
    formData.primeAutoConsoPanneaux +
    formData.recuperationTvaPanneaux;

  formData.coutProjetAideDeduite = formData.coutProjet - formData.totalAide;

  function calculateBillOver20Years() {
    let currentResult =
      formData.factureElectricite + formData.factureSecondaire;
    let resultArray = [currentResult];

    for (let i = 1; i < 20; i++) {
      currentResult *= 1.07;
      resultArray.push(currentResult);
    }

    const total = resultArray.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return total;
  }

  formData.coutFacture20ans = calculateBillOver20Years();

  //Modifier fonction prendre formData.consolAnnuelle et ajoute 7% en boucle jusqua 20 fois
  function calculateCoutFacture20ansAvecProjet() {
    let E5;
    if (formData.sourceType === "ELECTRICITE") {
      if (formData.energieType === "Ballon") {
        const X = formData.factureElectricite - formData.depenseECS;
        E5 = formData.depenseFuturePanneaux - X;
      } else if (formData.energieType === "Chaudiere") {
        E5 = formData.factureElectricite - formData.depenseFuturePanneaux;
      }
    } else {
      E5 =
        formData.factureElectricite +
        formData.factureSecondaire -
        formData.depenseFuturePanneaux;
    }

    let factureTotal = 0;
    let economiesTotal = 0;
    for (let year = 1; year <= 20; year++) {
      factureTotal += formData.consoAnnuelle * Math.pow(1.07, year); // Use formData.consoAnnuelle for factureTotal
      economiesTotal += E5 * Math.pow(1.07, year); // Use E5 for economiesTotal
    }

    formData.coutFacture20ansAvecProjet = formData.consoAnnuelle - E5;

    return formData.coutFacture20ansAvecProjet;
  }

  formData.coutFacture20ansAvecProjet = calculateCoutFacture20ansAvecProjet();

  function calculateGainSur20Ans() {
    return (
      formData.coutFacture20ans -
      formData.coutFacture20ansAvecProjet -
      formData.coutProjetAideDeduite
    );
  }
  console.log(formData);

  formData.gainSur20ans = calculateGainSur20Ans();

  // const handlePompeModeleChange = (value) => {
  //   if (value === "0") {
  //     // Seulement mettre à jour depenseChauffage à 0 si la condition est remplie
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       pompeModeleSelected: value,
  //       depenseChauffage: 0,
  //     }));
  //   } else {
  //     // Sinon, juste mettre à jour pompeModeleSelected
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       pompeModeleSelected: value,
  //     }));
  //   }
  // };

  // formData.depenseChauffage = handlePompeModeleChange();

  const calculateConsoAnnuellePompeAirAir = () => {
    if (formData.pompeAirAirSelected === "0") {
      return 0;
    }
    
    // Estimation de la consommation annuelle basée sur le modèle sélectionné
    const consoMatrix = {
      "7sorties": 3500,
      "6sorties": 3000,
      "5sorties": 2500,
      "4sorties": 2000,
      "3sorties": 1500,
      "2splits": 1000
    };
    
    return consoMatrix[formData.pompeAirAirSelected] || 0;
  };

  formData.consoAnnuellePompeAirAir = calculateConsoAnnuellePompeAirAir();

  const calculateDepenseFuturePompeAirAir = () => {
    if (formData.pompeAirAirSelected === "0") {
      return 0;
    }
    
    return formData.consoAnnuellePompeAirAir * 0.17;
  };

  formData.depenseFuturePompeAirAir = calculateDepenseFuturePompeAirAir();

  const calculateCoutProjetPompeAirAir = () => {
    if (formData.pompeAirAirSelected === "0") {
      return 0;
    }
    
    // Prix des modèles de pompe à chaleur air/air
    const pompeAirAirPrices = {
      "Fournitures et pose d'une air air 7 sorties (19990€)": 19990,
      "Fournitures et pose d'une air air 6 sorties (17490€)": 17490,
      "Fournitures et pose d'une air air 5 sorties (14490€)": 14490,
      "Fournitures et pose d'une air air 4 sorties (12350€)": 12350,
      "Fournitures et pose d'une air air 3 sorties (9899€)": 9899,
      "Fournitures et pose d'une air air 2 sorties (3900€)": 3900
    };
    // Récupérer le prix du modèle sélectionné
    const pompePrice = pompeAirAirPrices[formData.pompeAirAirSelected] || 0;
    // Ajouter le prix du cache climat si sélectionné
    let coutTotal = pompePrice;
    if (formData.cacheClimPompeAirSelected === "Avec") {
      coutTotal += 590;
    }
    return coutTotal;
  };

  formData.coutProjetPompeAirAir = calculateCoutProjetPompeAirAir();

  const calculateMaPrimePompeAirAir = () => {
    if (formData.pompeAirAirSelected === "0" || formData.aideColor === "rose") {
      return 0;
    }
    
    const maPrimeMatrix = {
      bleu: 2500,
      jaune: 2000,
      rose: 0,
      violet: 1500
    };
    
    return maPrimeMatrix[formData.aideColor.toLowerCase()] || 0;
  };

  formData.maPrimePompeAirAir = calculateMaPrimePompeAirAir();

  const calculateAidesCeePompeAirAir = () => {
    if (formData.pompeAirAirSelected === "0" || formData.sourceType === "ELECTRICITE" || formData.sourceType === "CONDENSATION") {
      return 0;
    }
    
    const aidesCeeMatrix = {
      bleu: 2400,
      jaune: 2050,
      rose: 1400,
      violet: 1400
    };
    
    return aidesCeeMatrix[formData.aideColor.toLowerCase()] || 0;
  };

  formData.aidesCeePompeAirAir = calculateAidesCeePompeAirAir();

  return (
    <Box width="full" px={16}>
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mb={6}
      >
        <Box>
          <Heading fontSize={"24px"} mb={1} fontWeight={"510"} color="#2D3748">
            Projet du client
          </Heading>
          <Text color="#8C8C8C" fontWeight={"400"} fontSize="16px">
            Sélectionnez le projet adapté pour le client
          </Text>
        </Box>
        <Button
          w="120px"
          h="40px"
          bgColor={"white"}
          color={"#30C9FF"}
          fontWeight={"600"}
          borderRadius={"8px"}
          border="1px solid"
          borderColor="#30C9FF"
          _hover={{
            bgColor: "#30C9FF",
            color: "white",
            transform: "translateY(-2px)",
            transition: "all 0.2s",
          }}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "20px", md: "30px" }}
        borderRadius="8px"
        bg="#FCFDFF"
        align="center"
        boxShadow="0px 4px 20px rgba(0, 0, 0, 0.05)"
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          width={"100%"}
          gap={10}
        >
          {/* Première rangée */}
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            width={"100%"}
            gap={8}
          >
            {/* Ballon Thermodynamique */}
            <Box
              w={"380px"}
              h={"520px"}
              bg="white"
              borderRadius={"16px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={4}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="100px"
              >
                <Image src={Picto2} boxSize="40px" />
              </Box>
              <Box p={6}>
                <Text
                  fontSize="13px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={4}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Ballon Thermodynamique
                </Text>
                <VStack
                  divider={<StackDivider borderColor="#F4F4F4" />}
                  align="stretch"
                  w="full"
                  spacing={3}
                >
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        CONSO ANNUELLE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {Math.round(formData.consoAnnuelleBallon)} kWh
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        DEPENSE ACTUELLE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.ballonThermoSelected === "0"
                        ? 0
                        : formData.depenseECS?.toFixed()}{" "}
                      €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        DEPENSE FUTURE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.depenseFutureBallon?.toFixed()} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        COUT DU PROJET
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.coutProjetBallon} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        AIDE MAPRIME RENOV
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.maPrimeBallon} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        AIDES CEE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.aidesCeeBallon} €
                    </Text>
                  </Flex>
                </VStack>
              </Box>
            </Box>

            {/* Panneaux Photovoltaïques */}
            <Box
              w={"380px"}
              h={"520px"}
              bg="white"
              borderRadius={"16px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={4}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="100px"
              >
                <Image src={Picto4} boxSize="40px" />
              </Box>
              <Box p={6}>
                <Text
                  fontSize="13px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={4}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Panneaux Photovoltaïques
                </Text>
                <VStack
                  divider={<StackDivider borderColor="#F4F4F4" />}
                  align="stretch"
                  w="full"
                  spacing={3}
                >
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        PANNEAUX SELECTIONNES
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.panneauxSelected}
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        CONSO ANNUELLE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.panneauxSelected === "0"
                        ? 0
                        : Math.round(formData.consoAnnuellePanneaux)}{" "}
                      kWh
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        PRODUCTION ANNUELLE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {Math.round(formData.productionAnnuellePanneaux)} kWh
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        DEPENSE FUTURE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.depenseFuturePanneaux} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        COUT DU PROJET
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.coutProjetPanneaux} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        PRIME AUTO CONSOMATION
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.primeAutoConsoPanneaux} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        RECUPERATION TVA
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.recuperationTvaPanneaux} €
                    </Text>
                  </Flex>
                </VStack>
              </Box>
            </Box>
          </Box>

          {/* Deuxième rangée */}
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            width={"100%"}
            gap={8}
          >
            {/* Pompe à chaleur air/eau */}
            <Box
              w={"380px"}
              h={"520px"}
              bg="white"
              borderRadius={"16px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={4}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="100px"
              >
                <Image src={Picto3} boxSize="40px" />
              </Box>
              <Box p={6}>
                <Text
                  fontSize="13px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={4}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Pompe à chaleur air/eau
                </Text>
                <VStack
                  divider={<StackDivider borderColor="#F4F4F4" />}
                  align="stretch"
                  w="full"
                  spacing={3}
                >
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        POMPE MODELE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.pompeModeleSelected}
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        POMPE PUISSANCE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.pompeSelected} kWh
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        CONSO ANNUELLE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.consoAnnuellePompe} kWh
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        DEPENSE CHAUFFAGE ACTUELLE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.pompeModeleSelected === "0"
                        ? 0
                        : formData.depenseChauffage?.toFixed()}{" "}
                      €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        DEPENSE FUTURE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.depenseFuturePompe?.toFixed()} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        COUT DU PROJET
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.coutProjetPompe} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        AIDE MAPRIME RENOV
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.maPrimePompe} €
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        AIDE CEE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.aidesCeePompe} €
                    </Text>
                  </Flex>
                </VStack>
              </Box>
            </Box>

            {/* Pompe à chaleur air/air */}
            <Box
              w={"380px"}
              h={"520px"}
              bg="white"
              borderRadius={"16px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={4}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="100px"
              >
                <Image src={Picto2} boxSize="40px" />
              </Box>
              <Box p={6}>
                <Text
                  fontSize="13px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={4}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Pompe à chaleur air/air
                </Text>
                <VStack
                  divider={<StackDivider borderColor="#F4F4F4" />}
                  align="stretch"
                  w="full"
                  spacing={3}
                >
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        POMPE AIR/AIR MODELE
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.pompeAirAirSelected === "0" ? "Aucun" : formData.pompeAirAirSelected}
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        CACHE CLIM
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.cacheClimPompeAirSelected}
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <HStack spacing={2}>
                      <Image src={Picto1} boxSize="6px" />
                      <Text fontSize="12px" color="#737373">
                        COUT DU PROJET
                      </Text>
                    </HStack>
                    <Text fontSize="12px" fontWeight="bold">
                      {formData.coutProjetPompeAirAir} €
                    </Text>
                  </Flex>
                </VStack>
              </Box>
            </Box>
          </Box>
        </Box>
      </Flex>
      <Flex justifyContent="flex-end" mt={6}>
        <Button
          w="240px"
          h="45px"
          bgColor="#30C9FF"
          color="#FCFDFF"
          fontWeight="600"
          fontSize="13px"
          borderRadius="8px"
          _hover={{
            bgColor: "#30C9FF",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 20px rgba(48, 201, 255, 0.15)",
          }}
          transition="all 0.2s"
          onClick={onNext}
        >
          Confirme les informations
        </Button>
      </Flex>
    </Box>
  );
};

export default StepOne;
